<template>
  <v-alert
    v-if="isViewAsMemberEnabled"
    data-testid="view-as-member-banner"
    type="info"
    variant="tonal"
    density="compact"
    :icon="mdiAccountEye"
    class="view-as-member-banner"
    border="start"
  >
    <div class="d-flex flex-wrap align-center ga-2">
      <span>
        You're viewing the site as a regular member. Server privileges are unchanged — this only changes what you see.
      </span>
      <v-spacer />
      <v-btn
        data-testid="view-as-member-banner-exit"
        size="small"
        color="primary"
        variant="flat"
        @click="setViewAsMember(false)"
      >
        Exit member view
      </v-btn>
    </div>
  </v-alert>
</template>

<script setup lang="ts">
import { mdiAccountEye } from "@mdi/js";
import { useViewAsMember } from "@/composables/useViewAsMember";

const { isViewAsMemberEnabled, setViewAsMember } = useViewAsMember();
</script>

<style scoped>
.view-as-member-banner {
  margin: 12px 16px 0;
  border-radius: var(--th-radius-card, 12px);
}
</style>
